(function () {
  'use strict';

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '$') + parts.join('.');
  }

  function make(tag, cls, text, label) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    if (text) { n.textContent = text; }
    if (label) { n.setAttribute('aria-label', label); }
    if (tag === 'button') { n.type = 'button'; }
    return n;
  }

  function addCss(id, css) {
    if (document.getElementById(id)) return;
    var tag = document.createElement('style');
    tag.id = id;
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  /* Height of whatever sticky header is in play, so scrolled-to headings do
     not end up hidden underneath it. */
  function headerOffset() {
    var best = 0;
    document.querySelectorAll('header, .hdt-header, [class*=sticky]').forEach(function (el) {
      var st = window.getComputedStyle(el);
      if (st.position !== 'fixed' && st.position !== 'sticky') return;
      var r = el.getBoundingClientRect();
      if (r.top <= 4 && r.height > best && r.height < 220) { best = r.height; }
    });
    return best + 20;
  }

  function scrollToEl(el) {
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function injectSwatchCss() {
    addCss('fl-swatch-css',
      '.fl-sw label span{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;clip-path:inset(50%)!important;white-space:nowrap!important;border:0!important;}'
      + '.fl-opt__val{overflow-wrap:anywhere;}');
  }

  function initGallery(root) {
    var thumbs = root.querySelectorAll('[data-fl-thumb]');
    var slides = root.querySelectorAll('[data-fl-slide]');
    if (!thumbs.length) return;
    function show(i) {
      thumbs.forEach(function (t) { t.setAttribute('aria-selected', t.dataset.flThumb === String(i)); });
      slides.forEach(function (s) {
        if (s.dataset.flSlide === String(i)) { s.setAttribute('data-active', ''); }
        else { s.removeAttribute('data-active'); }
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(t.dataset.flThumb); });
    });
    root.flShowSlide = show;
  }

  /* The Size Guide link scrolls to the Fit and Size Guide section when that
     section is on the page, and only falls back to the popup when it is not.
     Runs before initModal, and strips the modal hook so both never fire. */
  function initSizeGuideJump(root) {
    var target = document.querySelector('.fl-fit');
    if (!target) return;
    var section = target.closest('.fl-sec') || target;
    root.querySelectorAll('[data-fl-modal-open^="fl-size-"]').forEach(function (btn) {
      btn.removeAttribute('data-fl-modal-open');
      btn.addEventListener('click', function () { scrollToEl(section); });
    });
  }

  function injectLightboxCss() {
    addCss('fl-lightbox-css', ''
      + '.fl-lb{position:fixed;inset:0;z-index:10000;display:none;align-items:center;justify-content:center;background:rgba(18,17,16,.94);}'
      + '.fl-lb.is-open{display:flex;}'
      + '.fl-lb__fig{position:relative;margin:0;max-width:min(1100px,92vw);max-height:88vh;display:flex;align-items:center;justify-content:center;}'
      + '.fl-lb__img{max-width:100%;max-height:88vh;width:auto;height:auto;display:block;object-fit:contain;cursor:zoom-in;transition:transform .25s ease;}'
      + '.fl-lb__img.is-zoomed{cursor:zoom-out;transform:scale(2);}'
      + '.fl-lb__btn{position:absolute;top:50%;transform:translateY(-50%);width:52px;height:52px;border:0;border-radius:50%;background:rgba(255,255,255,.92);color:#1C1B1A;font-size:26px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background .2s ease;}'
      + '.fl-lb__btn:hover{background:#FDB913;}'
      + '.fl-lb__btn--prev{left:max(16px,calc(50vw - 620px));}'
      + '.fl-lb__btn--next{right:max(16px,calc(50vw - 620px));}'
      + '.fl-lb__x{position:absolute;top:22px;right:22px;width:44px;height:44px;border:0;border-radius:50%;background:rgba(255,255,255,.92);color:#1C1B1A;font-size:22px;line-height:1;cursor:pointer;z-index:2;}'
      + '.fl-lb__x:hover{background:#FDB913;}'
      + '.fl-lb__count{position:absolute;bottom:24px;left:50%;transform:translateX(-50%);margin:0;font-family:Inter,sans-serif;font-size:12px;letter-spacing:.12em;text-transform:uppercase;color:rgba(255,255,255,.78);}'
      + '.fl-gal__main{cursor:zoom-in;}'
      + '@media(max-width:768px){.fl-lb__btn{width:42px;height:42px;font-size:22px;}.fl-lb__btn--prev{left:10px;}.fl-lb__btn--next{right:10px;}.fl-lb__img.is-zoomed{transform:scale(1.6);}}');
  }

  function bestSrc(img) {
    var set = img.getAttribute('srcset');
    if (!set) return img.currentSrc || img.src;
    var best = null, bestW = 0;
    set.split(',').forEach(function (part) {
      var bits = part.trim().split(/\s+/);
      if (!bits[0]) return;
      var w = parseInt((bits[1] || '0w').replace('w', ''), 10) || 0;
      if (w >= bestW) { bestW = w; best = bits[0]; }
    });
    return best || img.currentSrc || img.src;
  }

  function initLightbox(root) {
    var main = root.querySelector('.fl-gal__main');
    if (!main) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-fl-slide]'));
    var photos = slides.filter(function (s) {
      return s.querySelector('img') && !s.querySelector('iframe, video, model-viewer');
    });
    if (!photos.length) return;

    injectLightboxCss();

    var lb = make('div', 'fl-lb', null, 'Product image viewer');
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    var closeBtn = make('button', 'fl-lb__x', '\u00D7', 'Close');
    var prevBtn = make('button', 'fl-lb__btn fl-lb__btn--prev', '\u2039', 'Previous image');
    var nextBtn = make('button', 'fl-lb__btn fl-lb__btn--next', '\u203A', 'Next image');
    var fig = make('figure', 'fl-lb__fig');
    var img = make('img', 'fl-lb__img');
    var count = make('p', 'fl-lb__count');

    fig.appendChild(img);
    lb.appendChild(closeBtn);
    lb.appendChild(prevBtn);
    lb.appendChild(fig);
    lb.appendChild(nextBtn);
    lb.appendChild(count);
    document.body.appendChild(lb);

    var i = 0, lastFocus = null;
    if (photos.length < 2) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
      count.style.display = 'none';
    }

    function render() {
      var src = photos[i].querySelector('img');
      img.src = bestSrc(src);
      img.alt = src.alt || '';
      img.classList.remove('is-zoomed');
      count.textContent = (i + 1) + ' / ' + photos.length;
    }
    function open(index) {
      lastFocus = document.activeElement;
      i = index;
      render();
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }
    function close() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
    }
    function step(dir) {
      i = (i + dir + photos.length) % photos.length;
      render();
    }

    main.addEventListener('click', function () {
      var active = root.querySelector('[data-fl-slide][data-active]');
      if (!active) return;
      if (!active.querySelector('img') || active.querySelector('iframe, video, model-viewer')) return;
      var at = photos.indexOf(active);
      open(at < 0 ? 0 : at);
    });

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { step(-1); });
    nextBtn.addEventListener('click', function () { step(1); });
    img.addEventListener('click', function () { img.classList.toggle('is-zoomed'); });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target === fig) { close(); } });

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); }
      else if (e.key === 'ArrowLeft') { step(-1); }
      else if (e.key === 'ArrowRight') { step(1); }
    });

    var startX = null;
    lb.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) { step(dx > 0 ? -1 : 1); }
      startX = null;
    }, { passive: true });
  }

  function initModal(root) {
    root.querySelectorAll('[data-fl-modal-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var m = document.getElementById(btn.dataset.flModalOpen);
        if (m) { m.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      });
    });
    root.querySelectorAll('[data-fl-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var m = btn.closest('.fl-modal');
        if (m) { m.classList.remove('is-open'); document.body.style.overflow = ''; }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var any = root.querySelectorAll('.fl-modal.is-open');
      if (!any.length) return;
      any.forEach(function (m) { m.classList.remove('is-open'); });
      document.body.style.overflow = '';
    });
  }

  function initQty(root) {
    root.querySelectorAll('[data-fl-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.dataset.step === 'up' ? 1 : -1;
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function initReviewJump(root) {
    var rows = root.querySelectorAll('.fl-buy__rate');
    if (!rows.length) return;
    function findTarget() {
      return document.getElementById('fl-reviews')
        || document.querySelector('.fl-jdgm')
        || document.querySelector('.jdgm-widget, .jdgm-rev-widg');
    }
    rows.forEach(function (row) {
      row.addEventListener('click', function (e) {
        var target = findTarget();
        if (!target) return;
        e.preventDefault();
        scrollToEl(target);
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#fl-reviews');
        }
      });
    });
  }

  function imageKey(url) {
    if (!url) return '';
    var name = url.split('?')[0].split('/').pop();
    return name.replace(/_\d+x\d*(?=\.)/, '').replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original)(?=\.)/, '');
  }

  function initVariants(root) {
    var dataEl = root.querySelector('[data-fl-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    injectSwatchCss();

    var idField = root.querySelector('[data-fl-variant-id]');
    var priceEl = root.querySelector('[data-fl-price]');
    var wasEl = root.querySelector('[data-fl-was]');
    var saveEl = root.querySelector('[data-fl-save]');
    var stockEl = root.querySelector('[data-fl-stock]');
    var atcEl = root.querySelector('[data-fl-atc]');
    var finEl = root.querySelector('[data-fl-fin]');
    var fmt = root.dataset.flCurrency || '$';
    var currentId = idField ? idField.value : null;
    var shopVariants = null;

    fetch(window.location.pathname.split('?')[0] + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (d && d.variants) { shopVariants = d.variants; showVariantImage(currentId); }
      })
      .catch(function () {});

    function showVariantImage(id) {
      if (!shopVariants || !id || !root.flShowSlide) return;
      var hit = null;
      shopVariants.forEach(function (sv) { if (String(sv.id) === String(id)) { hit = sv; } });
      if (!hit || !hit.featured_image || !hit.featured_image.src) return;
      var want = imageKey(hit.featured_image.src);
      if (!want) return;
      var slides = root.querySelectorAll('[data-fl-slide]');
      for (var n = 0; n < slides.length; n++) {
        var im = slides[n].querySelector('img');
        if (im && imageKey(im.getAttribute('src') || im.src) === want) {
          root.flShowSlide(slides[n].dataset.flSlide);
          return;
        }
      }
    }

    function selected() {
      var out = [];
      root.querySelectorAll('[data-fl-optgroup]').forEach(function (g) {
        var c = g.querySelector('input:checked');
        out.push(c ? c.value : null);
        var label = g.querySelector('[data-fl-optval]');
        if (label && c) { label.textContent = c.value; }
      });
      return out;
    }

    function match(vals) {
      return variants.find(function (v) {
        return vals.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }

    function apply() {
      var v = match(selected());
      if (!v) return;
      currentId = v.id;
      if (idField) idField.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price, fmt);
      if (wasEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          wasEl.textContent = money(v.compare_at_price, fmt);
          wasEl.style.display = '';
          if (saveEl) {
            saveEl.textContent = 'Save ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
            saveEl.style.display = '';
          }
        } else {
          wasEl.style.display = 'none';
          if (saveEl) saveEl.style.display = 'none';
        }
      }
      if (finEl) finEl.textContent = money(Math.round(v.price / 4), fmt);
      if (stockEl) {
        var low = parseInt(stockEl.dataset.flLow || '10', 10);
        if (v.available && v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= low) {
          stockEl.textContent = 'Only ' + v.inventory_quantity + ' left in stock';
          stockEl.style.display = '';
        } else if (!v.available) {
          stockEl.style.display = 'none';
        } else {
          stockEl.style.display = stockEl.dataset.flFallback ? '' : 'none';
          if (stockEl.dataset.flFallback) stockEl.textContent = stockEl.dataset.flFallback;
        }
      }
      if (atcEl) {
        atcEl.disabled = !v.available;
        atcEl.textContent = v.available ? (atcEl.dataset.flLabel || 'Add to Cart') : 'Sold Out';
      }
      var sticky = document.querySelector('[data-fl-sticky-price]');
      if (sticky) sticky.textContent = money(v.price, fmt);
      var stickyId = document.querySelector('[data-fl-sticky-id]');
      if (stickyId) stickyId.value = v.id;
      showVariantImage(v.id);
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }

    root.querySelectorAll('[data-fl-optgroup] input').forEach(function (i) {
      i.addEventListener('change', apply);
    });
    apply();
  }

  function initAddons(root) {
    root.querySelectorAll('[data-fl-addon-toggle]').forEach(function (cb) {
      var target = root.querySelector('#' + cb.dataset.flAddonToggle);
      if (!target) return;
      function sync() {
        target.style.display = cb.checked ? '' : 'none';
        if (!cb.checked) target.value = '';
      }
      cb.addEventListener('change', sync);
      sync();
    });
  }

  function initPersonalize(root) {
    var wrap = root.querySelector('[data-fl-person]');
    if (!wrap) return;
    var cb = wrap.querySelector('[data-fl-person-toggle]');
    var fields = wrap.querySelector('[data-fl-person-fields]');
    if (!cb || !fields) return;
    var inputs = fields.querySelectorAll('input');
    function sync() {
      var on = cb.checked;
      fields.hidden = !on;
      inputs.forEach(function (i) {
        i.disabled = !on;
        if (!on) { i.value = ''; }
      });
    }
    cb.addEventListener('change', sync);
    sync();
  }

  function initCart(root) {
    var form = root.querySelector('[data-fl-form]');
    if (!form) return;
    var engraveId = root.dataset.flEngraveId;
    var cb = root.querySelector('[data-fl-person-toggle]');

    form.addEventListener('submit', function (e) {
      var wants = cb && cb.checked && engraveId;
      if (!wants) return;
      e.preventDefault();
      var btn = e.submitter;
      var toCheckout = btn && btn.name === 'checkout';
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (d) { throw new Error(d.description || 'Add failed'); });
          }
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: [{ id: Number(engraveId), quantity: 1 }] })
          });
        })
        .then(function () {
          window.location.href = toCheckout ? '/checkout' : '/cart';
        })
        .catch(function (err) {
          if (btn) { btn.disabled = false; btn.textContent = label; }
          window.alert(err.message || 'Sorry, that could not be added to your cart.');
        });
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-fl-sticky]');
    var anchor = document.querySelector('[data-fl-sticky-anchor]');
    if (!bar || !anchor) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(anchor);
    var sel = bar.querySelector('select');
    if (sel) {
      sel.addEventListener('change', function () {
        var hidden = bar.querySelector('[data-fl-sticky-id]');
        if (hidden) hidden.value = sel.value;
      });
    }
  }

  function initChips(root) {
    root.querySelectorAll('[data-fl-chip]').forEach(function (c) {
      c.addEventListener('click', function () {
        c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') !== 'true');
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-fl-pdp]').forEach(function (root) {
      if (root.dataset.flBooted) return;
      root.dataset.flBooted = '1';
      initGallery(root);
      initLightbox(root);
      initSizeGuideJump(root);
      initModal(root);
      initQty(root);
      initVariants(root);
      initAddons(root);
      initPersonalize(root);
      initCart(root);
      initReviewJump(root);
    });
    document.querySelectorAll('[data-fl-reviews]').forEach(initChips);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', boot);
})();
